export default {
    getColours: [
        '#b3de69',
        '#fb8072',
        '#bc80bd',
        '#9c755f',
        '#bab0ab',
        '#ffe119',
        '#8dd3c7',
        '#ff9da7',
        '#80b1d3',
        '#fdb462',
        '#fccde5',
        '#dabeec',
        '#bebada',
        '#ccebc5',
        '#4e79a7',
        '#f28e2c',
        '#e15759',
        '#76b7b2',
        '#59a14f',
        '#af7aa1',
        '#F7E188',
        '#54BFB5',
        '#8CE6FF'
    ],
    getPillarColours: ['#4e79a7', '#f28e2c', '#af7aa1', '#76b7b2', '#59a14f'],
    getSocialnetworkColours: {
        nb: '#A9A9A9',
        fb: '#4267b2',
        yt: '#FF0000',
        ig: '#C13584',
        tw: '#38A1F3'
    },
    getIndicatorColours: { green: '#8dd3c7', orange: '#fdc086', red: '#fb8072' }
};
